<template>
  <v-row dense>
    <v-col cols="12">
      <Filtro />
    </v-col>
    <v-col cols="12">
      <Parametros />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ParametrosEmpresa",

  components: {
    Filtro: () => import("./components/Filtro"),
    Parametros: () => import("./components/Parametros")
  }
};
</script>
